export const TOS_LIST = "TOS_LIST";
export const TOS = "TOS";